import styled from 'styled-components'

import e2eClasses from 'helpers/automation'

export const RefundContainer = styled.div.attrs(() => ({
  className: e2eClasses('corporate.agreementsRefundForm')
}))`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 16px;
  padding: 0 10px;
`
export const LabelInformation = styled.label`
  color: ${({ theme }) => theme.colors.doveGray};
  font-family: ${({ theme }) => theme.fonts.regular};
  line-height: 22px;
`

export const BoldText = styled.p`
  font-weight: bold;
`

export const Separator = styled.div`
  height: 15px;
`
export const RefundInformationContainer = styled.div.attrs(() => ({
  className: e2eClasses('corporate.agreementsRefundInformation')
}))`
  margin-bottom: 48px;
`
